import styled from 'styled-components';

export const SectionTitle = styled.div`
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(8, 10, 37, 0.1);
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: #101938;
  width: 100%;
  margin-top: 18px;
`;

export const Attribute = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: rgba(14, 26, 64, 0.45);
  margin-top: ${(props) => (props.withMarginTop ? '10px' : '0')};
`;

export const Value = styled.div`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.85);
`;
